import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar__nav" }

import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'RealEstateBrokerMemberNavbarItems',
  setup(__props) {

const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.account.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.account.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.company.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.company.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.invoices.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.invoices.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.activities.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.activities.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})